import {
  faChevronLeft,
  faChevronRight,
  faSearch,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import BannerImage from "../assets/images/qr-connect-banner.png";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import ctaOption from "../assets/images/cta-option-1.png";
import aboutImage from "../assets/images/about-image.png";
import homeService from "../services/home-page-services";
import cctv from "../assets/icons/cctv.png";
import transformer from "../assets/icons/transformer.png";
import dg from "../assets/icons/dg.png";
import boreWell from "../assets/icons/bore-well.png";
import wtp from "../assets/icons/wtp.png";
import stp from "../assets/icons/stp.png";
import motor from "../assets/icons/motor.png";
import firSafety from "../assets/icons/fire-safety.png";
import htlt from "../assets/icons/ht-lt.png";
import lift from "../assets/icons/lift.png";
import { fetchSubCategories } from "../services/CategorySubCategoryService";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import HomeBlogs from "../components/home/home-blog";
import { useNavigate } from "react-router-dom";
import { handleErrors } from "../utils/errorHandler";

const HomePage = () => {
  const [services, setServices] = useState([]);
  const [feature, setFeature] = useState([]);
  const [homeAdImage, setHomeAdImage] = useState("");
  const [homeAdImageMobile, setHomeAdImageMobile] = useState("");
  const navigate = useNavigate();
  const [subCategories, setSubCategories] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  useEffect(() => {
    homeService.submitNewlyaddedForm().then((response) => {
      if (response.data.isSuccess) {
        setServices(response.data.result);
      }
    });
  }, []);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await homeService.submitFeaturedForm();
        if (response.data.isSuccess) {
          setFeature(response.data.result);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchServices();
  }, []);
  useEffect(() => {
    const fetchAdsBanner = async () => {
      try {
        const response = await homeService.getAdsbanner();
        if (response) {
          setHomeAdImage(response.data.result.homePage1);
          setHomeAdImageMobile(response.data.result.topBannerMobile);
        }
      } catch (error) {
        console.error("Error fetching banner:", error);
      }
    };

    fetchAdsBanner();
  }, []);
  const formattedCategory = (category) =>
    category.replace(/&/g, "$").replace(/ /g, "-").toLowerCase();

  const handleCardClick = (typeOfWorkObj) => {
    navigate(`/services?typeOfWork=${typeOfWorkObj.id}`);
  };

  const handleCategoriesClick = (subcategory) => {
    const formattedSubCategoryText = formattedCategory(subcategory);
    navigate(`/services?subCategory=${formattedSubCategoryText}`);
  };
  const handleMainCategoriesClick = (category) => {
    const formattedCategoryText = formattedCategory(category);
    navigate(`/services?category=${formattedCategoryText}`);
  };
  useEffect(() => {
    const fetchData = async (id) => {
      try {
        const subCategoriesData = await fetchSubCategories();
        const all = subCategoriesData.result || [];
        setSubCategories(all);
        setFilteredOptions(all);
      } catch (error) {
        handleErrors(error);
      }
    };

    fetchData();
  }, []);
  const handleChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);

    if (value.trim().length === 0) {
      setFilteredOptions(subCategories); // show all
    } else {
      const filtered = subCategories.filter((item) =>
        item.subCategoryName.toLowerCase().startsWith(value.toLowerCase())
      );
      setFilteredOptions(filtered);
    }

    setShowDropdown(true);
  };

  const handleSelect = (subCategoryName) => {
    setSearchInput(subCategoryName);
    setShowDropdown(false);
  };

  return (
    <>
      <section className="home-banner-section">
        <div className="custom-container">
          <div className="row align-items-center">
            <div className="col-12 col-sm-12 col-md-7 col-lg-6">
              <div className="banner-title">
                <h1>Reliable Vendors. Hassle-Free Facility Management.</h1>
                <p>
                  Easily discover, connect, and manage verified service vendors
                  for your facility needs all in one place. From housekeeping to
                  HVAC, Curenza(Omshakthi Monitoring Service Private Limited)
                  brings transparency, reliability, and efficiency to facility
                  management.
                </p>
              </div>

              <div className="banner-search" style={{ position: "relative" }}>
                <div className="banner-input">
                  <FontAwesomeIcon icon={faSearch} />
                  <input
                    type="text"
                    placeholder="Search for services you are looking for..."
                    value={searchInput}
                    onChange={handleChange}
                    onFocus={() => {
                      setFilteredOptions(subCategories); // show all on focus
                      setShowDropdown(true);
                    }}
                    onBlur={() => {
                      setTimeout(() => setShowDropdown(false), 100);
                    }}
                  />
                </div>

                {showDropdown && (
                  <ul className="search-dropdown">
                    {filteredOptions.length === 0 ? (
                      <li>No matches found</li>
                    ) : (
                      filteredOptions.map((option) => (
                        <li
                          key={option.id}
                          onClick={() => handleSelect(option.subCategoryName)}
                        >
                          {option.subCategoryName}
                        </li>
                      ))
                    )}
                  </ul>
                )}

                <div className="search-btn">
                  <button
                    className="btn orange-btn"
                    onClick={() => {
                      const matchedSubCategory = subCategories.find(
                        (item) =>
                          item.subCategoryName.toLowerCase().trim() ===
                          searchInput.toLowerCase().trim()
                      );

                      if (matchedSubCategory) {
                        const encoded = formattedCategory(
                          matchedSubCategory.subCategoryName
                        );
                        navigate(`/services?subCategory=${encoded}`);
                      } else {
                        navigate("/services");
                      }
                    }}
                  >
                    Search
                  </button>
                </div>
              </div>
              <div className="banner-categories">
                <div className="category-wrap banner-top-services-slider">
                  <ul>
                    <div className="swiper-arrows">
                      <div className="swiper-button-prev arrow-icon">
                        <FontAwesomeIcon icon={faChevronLeft} />
                      </div>
                      <div className="swiper-button-next arrow-icon">
                        <FontAwesomeIcon icon={faChevronRight} />
                      </div>
                    </div>
                    <Swiper
                      modules={[Autoplay, Navigation]}
                      // autoplay={{ delay: 7000, disableOnInteraction: false }}
                      loop={true}
                      spaceBetween={10}
                      slidesPerView={5}
                      slidesPerGroup={5}
                      navigation={{
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                      }}
                      breakpoints={{
                        320: {
                          slidesPerView: 3,
                          slidesPerGroup: 3,
                        },
                        576: {
                          slidesPerView: 5,
                          slidesPerGroup: 5,
                        },
                        768: {
                          slidesPerView: 3,
                          slidesPerGroup: 3,
                        },
                        1024: {
                          slidesPerView: 4,
                          slidesPerGroup: 4,
                        },
                        1280: {
                          slidesPerView: 3, // your original setting
                          slidesPerGroup: 3,
                        },
                      }}
                    >
                      <SwiperSlide>
                        <li>
                          <div
                            onClick={() =>
                              handleCardClick({
                                id: 44,
                                workTypeName: "CCTV - Repair & AMC ",
                              })
                            }
                          >
                            <div className="icon">
                              <img src={cctv} alt="" />
                            </div>
                            <span>CCTV - Repair & AMC</span>
                          </div>
                        </li>
                      </SwiperSlide>

                      <SwiperSlide>
                        <li>
                          <div
                            onClick={() =>
                              handleCardClick({
                                id: 8,
                                workTypeName: "DG - AMC and Service",
                              })
                            }
                          >
                            <div className="icon">
                              <img src={dg} alt="" />
                            </div>
                            <span>DG - AMC and Service</span>
                          </div>
                        </li>
                      </SwiperSlide>

                      <SwiperSlide>
                        <li>
                          <div
                            onClick={() =>
                              handleCardClick({
                                id: 40,
                                workTypeName: "WTP - Filter Service",
                              })
                            }
                          >
                            <div className="icon">
                              <img src={wtp} alt="" />
                            </div>
                            <span>WTP - Filter Service</span>
                          </div>
                        </li>
                      </SwiperSlide>
                      <SwiperSlide>
                        <li>
                          <div
                            onClick={() =>
                              handleCardClick({
                                id: 40,
                                workTypeName: "STP - Filter Service",
                              })
                            }
                          >
                            <div className="icon">
                              <img src={stp} alt="" />
                            </div>
                            <span>STP - Filter Service</span>
                          </div>
                        </li>
                      </SwiperSlide>
                      <SwiperSlide>
                        <li>
                          <div
                            onClick={() =>
                              handleCardClick({
                                id: 33,
                                workTypeName: "Motors/Pumps - Repair & Service",
                              })
                            }
                          >
                            <div className="icon">
                              <img src={motor} alt="" />
                            </div>
                            <span>Motors/Pumps - Repair & Service</span>
                          </div>
                        </li>
                      </SwiperSlide>
                      <SwiperSlide>
                        <li>
                          <div
                            onClick={() =>
                              handleCardClick({
                                id: 37,
                                workTypeName: "Fire & Safety",
                              })
                            }
                          >
                            <div className="icon">
                              <img src={firSafety} alt="" />
                            </div>
                            <span>Fire & Safety</span>
                          </div>
                        </li>
                      </SwiperSlide>
                      <SwiperSlide>
                        <li>
                          <div
                            onClick={() =>
                              handleCardClick({
                                id: 30,
                                workTypeName: "HT & LT works",
                              })
                            }
                          >
                            <div className="icon">
                              <img src={htlt} alt="" />
                            </div>
                            <span>HT & LT works</span>
                          </div>
                        </li>
                      </SwiperSlide>
                      <SwiperSlide>
                        <li>
                          <div
                            onClick={() =>
                              handleCardClick({
                                id: 19,
                                workTypeName: "Lift Maintenance",
                              })
                            }
                          >
                            <div className="icon">
                              <img src={lift} alt="" />
                            </div>
                            <span>Lift - Repair and Service</span>
                          </div>
                        </li>
                      </SwiperSlide>
                      <SwiperSlide>
                        <li>
                          <div
                            onClick={() =>
                              handleCardClick({
                                id: 7,
                                workTypeName: "Transformer Service/AMC",
                              })
                            }
                          >
                            <div className="icon">
                              <img src={transformer} alt="" />
                            </div>
                            <span>Transformer Service/AMC</span>
                          </div>
                        </li>
                      </SwiperSlide>
                      <SwiperSlide>
                        <li>
                          <div
                            onClick={() =>
                              handleCardClick({
                                id: 10,
                                workTypeName: "Borewell - New & Service",
                              })
                            }
                          >
                            <div className="icon">
                              <img src={boreWell} alt="" />
                            </div>
                            <span>Borewell - New & Service</span>
                          </div>
                        </li>
                      </SwiperSlide>
                    </Swiper>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-5 col-lg-6">
              <div className="banner-image">
                <img src={BannerImage} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="homepage-banner-ad">
        <div className="container d-lg-block d-none">
          <div className="row">
            <div className="col-12">
              <div className="ad-image">
                <img src={homeAdImage} alt="Home Page Banner" />
              </div>
            </div>
          </div>
        </div>
        <div className="container d-lg-none d-block">
          <div className="row">
            <div className="col-12">
              <div className="ad-image-mobile">
                <img src={homeAdImageMobile} alt="Home Page Banner" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="what-we-provide section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="title-btn-wrap">
                <div className="section-title">
                  <h2>
                    <span className="orange-text">New Services</span> we have
                    started
                  </h2>
                </div>
                <div className="see-all-btn">
                  <Link to="/services" className="btn orange-btn-outlined">
                    See All
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <Swiper
            slidesPerView={1}
            spaceBetween={20}
            modules={[Pagination, Autoplay]}
            pagination={{ clickable: true }}
            breakpoints={{
              576: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 40,
              },
              992: {
                slidesPerView: 5,
                spaceBetween: 30,
              },
            }}
            autoplay={{ delay: 7000, disableOnInteraction: false }}
          >
            {services.map((service) => (
              <SwiperSlide key={service.id}>
                <div
                  className="new-service-card"
                  onClick={() => handleCategoriesClick(service.subCategoryName)}
                >
                  <div className="image">
                    <img
                      src={service.subCategoryImage}
                      alt={service.subCategoryName}
                    />
                  </div>
                  <div className="service-name">
                    <h3>{service.subCategoryName}</h3>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      <section className="our-services section-padding pt-0">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="title-btn-wrap">
                <div className="section-title">
                  <h2>
                    <span className="orange-text">Popular</span> Services
                  </h2>
                </div>
                <div className="see-all-btn">
                  <Link to="/services" className="btn orange-btn-outlined">
                    See All
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <Swiper
            slidesPerView={1}
            spaceBetween={20}
            modules={[Pagination, Autoplay]}
            pagination={{ clickable: true }}
            breakpoints={{
              576: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 40,
              },
              992: {
                slidesPerView: 4,
                spaceBetween: 50,
              },
            }}
            autoplay={{ delay: 7000, disableOnInteraction: false }}
          >
            {feature.map((service) => (
              <SwiperSlide key={service.id}>
                <div
                  className="our-services-card"
                  onClick={() =>
                    handleMainCategoriesClick(service.categoryName)
                  }
                >
                  <div className="image">
                    <img
                      src={service.categoryThumb}
                      alt={service.categoryName}
                    />
                  </div>
                  <div className="service-name">
                    <h3>{service.categoryName}</h3>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      <section className="about-us">
        <div className="container">
          <div className="row align-items-center flex-column-reverse flex-lg-row">
            <div className="col-12 col-md-12 col-lg-6">
              <div className="about-image">
                <img src={aboutImage} alt="" />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-6">
              <div className="section-title">
                <h2>About Us</h2>
                <p>
                  At{" "}
                  <strong>
                    Curenza(Omshakthi Monitoring Service Private Limited)
                  </strong>
                  , we are dedicated to building smarter, cleaner, and more
                  sustainable cities that empower communities to thrive. As a
                  leading urban services provider, our mission is to enhance the
                  quality of life by delivering innovative solutions that
                  address the evolving needs of modern urban living.
                </p>
                <p>
                  From efficient waste management and infrastructure development
                  to sustainable urban planning and community engagement, we
                  offer a comprehensive range of services designed to create
                  safer, greener, and more connected cities. Our
                  forward-thinking approach integrates technology,
                  sustainability, and community partnerships to drive positive
                  change in every neighborhood we serve.
                </p>
              </div>
              <Link className="btn orange-btn" to="/about-us">
                Know More
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-section">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-11 mx-auto">
              <div className="cta-card">
                <div className="row">
                  <div className="col-12 col-md-8 col-lg-7 ">
                    <div className="section-title">
                      <h2>
                        Empowering Urban Growth with Modern Solutions and
                        Community-Driven Innovation.
                      </h2>
                      <div className="cta-btn-wrap">
                        <Link className="btn orange-btn" to="/careers">
                          Partner with Us
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-5  position-unset">
                    <div className="cta-img">
                      <img src={ctaOption} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonial">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section-title">
                <h2>What Our Customers Say</h2>
              </div>
            </div>
            <div className="col-12">
              <Swiper
                className="testimonial-slider"
                slidesPerView={1}
                spaceBetween={24}
                autoplay={true}
                modules={[Pagination]}
                pagination={{
                  clickable: true,
                }}
                breakpoints={{
                  576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                  991: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                  },
                  1200: {
                    slidesPerView: 3.5,
                    spaceBetween: 24,
                  },
                }}
              >
                <SwiperSlide>
                  <div class="reviews-carousel-card">
                    <div class="reviews-carousel-reviewer-info-container">
                      <div class="reviews-carousel-card-reviewer-info-container">
                        <div class="reviewer-info">
                          <span class="reviewer-display-name">
                            Joshua Sathyaraj
                          </span>
                        </div>
                        <div class="review-date">Apr 29, 2025</div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-star-rating-shop-badge-container">
                      <div class="yotpo-star-ratings">
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-review-content-container">
                      <p class="review-content" tabindex="-1">
                        Executive was so professional, he took all the
                        pre-measures and checks before the cleaning. At the end
                        A/C has been cleaned so well. His service was best,
                        smooth and clean.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div class="reviews-carousel-card">
                    <div class="reviews-carousel-reviewer-info-container">
                      <div class="reviews-carousel-card-reviewer-info-container">
                        <div class="reviewer-info">
                          <span class="reviewer-display-name">
                            Chandrayee Chaudhuri.
                          </span>
                        </div>
                        <div class="review-date">Apr 29, 2025</div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-star-rating-shop-badge-container">
                      <div class="yotpo-star-ratings">
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-review-content-container">
                      <p class="review-content" tabindex="-1">
                        Excellent AC servicing! The person was professional,
                        efficient, and did a fantastic job. Not only did they
                        service the AC thoroughly, but they also cleaned up the
                        place very nicely afterward. Truly impressed with their
                        work and attention to detail. Highly recommended!
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div class="reviews-carousel-card">
                    <div class="reviews-carousel-reviewer-info-container">
                      <div class="reviews-carousel-card-reviewer-info-container">
                        <div class="reviewer-info">
                          <span class="reviewer-display-name">
                            Spandan Bhattacharyya
                          </span>
                        </div>
                        <div class="review-date">Apr 28, 2025</div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-star-rating-shop-badge-container">
                      <div class="yotpo-star-ratings">
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-review-content-container">
                      <p class="review-content" tabindex="-1">
                        Very professional work from Prajapati and his
                        fellowmate. They identified the issue within few seconds
                        and told about the actual problem which is being faced.
                        And perform their work accordingly. Would strongly
                        recommend others to take his service.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div class="reviews-carousel-card">
                    <div class="reviews-carousel-reviewer-info-container">
                      <div class="reviews-carousel-card-reviewer-info-container">
                        <div class="reviewer-info">
                          <span class="reviewer-display-name">Sonali Bose</span>
                        </div>
                        <div class="review-date">02/24/25</div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-star-rating-shop-badge-container">
                      <div class="yotpo-star-ratings">
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-review-content-container">
                      <p class="review-content" tabindex="-1">
                        The work done by this professional was excellent however
                        I would like to give feedback about the previous
                        professional sent Jiarul was not at all happy , but this
                        time the ac is working fine
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div class="reviews-carousel-card">
                    <div class="reviews-carousel-reviewer-info-container">
                      <div class="reviews-carousel-card-reviewer-info-container">
                        <div class="reviewer-info">
                          <span class="reviewer-display-name">Deepak M.</span>
                        </div>
                        <div class="review-date">02/24/25</div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-star-rating-shop-badge-container">
                      <div class="yotpo-star-ratings">
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-review-content-container">
                      <p class="review-content" tabindex="-1">
                        Sarathi's service was very nice and he did everything in
                        a detailed manner. He even cleaned the floor after the
                        service. Would prefer him for future services.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </section>
      <HomeBlogs />
    </>
  );
};

export default HomePage;
